<template>
  <div>
    <!--最上段メニュー-->
    <v-app-bar color="light-blue lighten-4" hide-on-scroll>
      <v-spacer></v-spacer>
      <v-toolbar-title>GLOC おにぎり食堂</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>

    <!--エラー表示バー-->
    <v-alert v-if="hasError" type="error">
      {{ errorMessage }}
    </v-alert>

    <!--ダイアログ
      dialog == 1 ネットワーク切替の予告
      dialog == 2 トランザクション詰まった時の処置
      dialog == 3 コントラクトやサムネイル画像を読込み中のくるくる
-->
    <v-dialog v-model="dialog" v-if="dialog == 1" max-width="400px">
      <v-card max-width="100%" height="100%" class="d-flex flex-column">
        <v-card-text class="mt-3">
          <v-icon class="mt-5 mr-auto" color="red lighten-3">mdi-alert-circle</v-icon>
          <br />{{ config.contract_network }} ネットワークに接続していません
          <!--<br />イーサリアムメイン ネットワークに接続していません -->
          <br />メタマスクの切替画面に移ります
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-5 mb-3" color="blue lighten-3" elevation="5" large @click="
            dialog = 0;
          switchNetwork();
          ">
            👍OK!
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" v-if="dialog == 2" max-width="400px">
      <v-card max-width="100%" height="100%" class="d-flex flex-column">
        <v-card-text class="mt-3">
          <v-icon class="mt-5 mr-auto" color="red lighten-3">mdi-alert-circle</v-icon>
          <div>トランザクションが詰まった様です・・・</div>
          <div>
            Metamaskで詰まっているトランザクションをキャンセルして、もう一度トライしてみて下さい
          </div>
          <br />
          <div>Metamaskで"スピードアップ"しましたか？</div>
          <div>
            実はミントできているかも知れません
            <br /><a v-bind:href="openseaUrl" target="_blank">OpenSea</a>
            で確認してみて下さい
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-5 mb-3" color="blue lighten-3" elevation="5" large @click="gotoStart()">
            最初の画面に戻る
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" v-if="dialog == 3" max-width="400px">
      <v-card align="center">
        <!--上下スペースの調整方法が分からないので、こんなやり方を-->
        <v-card-text></v-card-text>
        <v-card-text></v-card-text>
        <v-card-text></v-card-text>
        <div>
          <v-progress-circular :size="30" :width="5" indeterminate color="grey"></v-progress-circular>
        </div>
        <v-card-text></v-card-text>
        <v-card-text> GLOCの保有状況を読込み中です </v-card-text>
        <v-card-text> {{ nftCards.length }} / {{ ghnTokensOfOwner.length }}</v-card-text>
        <v-card-text></v-card-text>
      </v-card>
    </v-dialog>

    <!--ここから本体-->
    <v-container fluid class="main-part">
      <!--ウォレット接続画面-->
      <v-row v-if="walletAddress == ''" justify="center">
        <v-col sm="12" md="8" lg="6">
          <v-card max-width="100%" height="100%" class="d-flex flex-column" elevation="5" color="amber lighten-4">
            <v-card-title>【ウォレット接続】</v-card-title>
            <v-card class="ma-10 mt-2 pa-5">
              <v-card-text>
                おにぎり食堂では、お持ちのGLOCから「おにぎりNFT」を作ることができます
              </v-card-text>
              <v-card-text>
                ・一杯のGLOCから作れるおにぎりは
                <a class="red--text">一週間に１個</a>です
                <br />
                ・<a class="red--text">GLOCがイベントごはん中は食堂を閉店</a>させていただきます
              </v-card-text>
              <v-card-text class="mb-5">
                <br />お持ちのGLOCを確認しますので、ウォレットの接続をお願いします
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="my-5" color="red lighten-3" elevation="5" large @click="connectWallet">
                  ウォレットを接続
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-col>
      </v-row>
      <!--おにぎりにするGLOCを選ぶ画面-->
      <v-row v-if="page == 1 && !paused && !ghnOnEvent" justify="center">
        <v-col sm="12" md="8" lg="6">
          <v-card max-width="100%" height="100%" class="d-flex flex-column" elevation="5" color="amber lighten-4">
            <v-card-title>【おにぎりにするGLOCの選択】</v-card-title>
            <v-card-text class="ml-5 pb-0">
              接続済ウォレット：{{ walletAddress.substring(0, 6) }}...{{
                walletAddress.substring(38, 42)
              }}
            </v-card-text>
            <v-card class="ma-10 mt-2 pa-5">
              <v-card-text v-if="ghnBalanceOf > 0">
                おにぎりにしたいGLOCを一杯選んで「厨房へ進む」を押してください<br />
              </v-card-text>
              <v-card-text v-if="ghnBalanceOf <= 0">
                このウォレットにはGLOCが見当たりません<br />
                ご確認ください
              </v-card-text>
              <v-container>
                <v-row dense>
                  <template v-for="(card, index) in nftCards">
                    <v-col v-bind:key="index" cols="6" sm="4" md="3">
                      <v-card>
                        <v-img :src="card.src">
                          <v-overlay v-if="!card.isReadyToOnigiri" :absolute=true :opacity=0.6>
                            <v-card-text class="white--text">おにぎり済です</v-card-text>
                          </v-overlay>
                        </v-img>
                        <v-card-text v-text="'Gohan Lover #' + card.title" class="pt-2 pb-0"></v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn v-if="!card.selected" color="blue lighten-5" elevation="5" small @click="select(index)"
                            v-bind:disabled="ghnBalanceOf <= 0 || !card.isReadyToOnigiri">
                            未選択
                          </v-btn>
                          <v-btn v-if="card.selected" color="blue lighten-1" elevation="5" small @click="select(index)"
                            v-bind:disabled="ghnBalanceOf <= 0 || !card.isReadyToOnigiri">
                            選択済
                          </v-btn>
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </template>
                </v-row>
              </v-container>
              <v-divider></v-divider>
              <v-row dense>
                <v-col>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="my-5" color="blue lighten-3" elevation="5" large @click="gotoStart()">
                      最初に戻る
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn class="my-5" color="red lighten-3" elevation="5" large @click="countIds(), (page = 2)"
                      v-bind:disabled="selectedCardsNumber() > ghnBalanceOf ||
                        selectedCardsNumber() == 0
                        ">
                      厨房へ進む
                    </v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-card>
          </v-card>
        </v-col>
      </v-row>
      <!--コントラクトが止まっている時の画面-->
      <v-row v-if="page == 1 && (paused || ghnOnEvent)" justify="center">
        <v-col sm="12" md="8" lg="6">
          <v-card max-width="100%" height="100%" class="d-flex flex-column" elevation="5" color="amber lighten-4">
            <v-card-title>【おにぎりにするGLOCの選択】</v-card-title>
            <v-card-text class="ml-5 pb-0">
              接続済ウォレット：{{ walletAddress.substring(0, 6) }}...{{
                walletAddress.substring(38, 42)
              }}
            </v-card-text>
            <v-card class="ma-10 mt-2 pa-5">
              <v-card-text v-if="ghnBalanceOf > 0">
                <div class="red--text">
                  GLOCの保有数 = {{ ghnBalanceOf }}
                </div>
                <div><br />食堂は準備中です</div>
              </v-card-text>
              <v-card-text v-if="ghnBalanceOf <= 0">
                GLOCの保有数がゼロです<br /><br />
                食堂は準備中です
              </v-card-text>
            </v-card>
          </v-card>
        </v-col>
      </v-row>
      <!--バーンミント以降の画面-->
      <v-row v-if="page == 2" justify="center">
        <v-col sm="12" md="8" lg="6">
          <v-card max-width="100%" height="100%" class="d-flex flex-column" elevation="5" color="amber lighten-4">
            <v-card-title>【おにぎり厨房】</v-card-title>
            <v-card-text class="ml-5 pb-0">
              接続済ウォレット：{{ walletAddress.substring(0, 6) }}...{{
                walletAddress.substring(38, 42)
              }}
            </v-card-text>
            <v-card class="ma-10 mt-2 pa-5">
              <v-container fluid>
                <v-row>
                  <v-card-text v-if="step < 3">
                    このGLOCをおにぎりにします！ <br /><br />
                    ※ミントする時にMetamaskが開きます<br />
                    「SAFE MINT」の文字を確認してから承認してください
                  </v-card-text>
                  <v-card-text v-if="step == 3">
                    お待たせしました！
                  </v-card-text>
                  <template v-for="(card, index) in nftCards">
                    <template v-if="card.selected">
                      <v-col v-bind:key="index" cols="6">
                        <v-card>
                          <v-img :src="card.src"></v-img>
                          <v-card-text v-text="'Gohan Lover #' + card.title"></v-card-text>
                        </v-card>
                      </v-col>
                    </template>
                  </template>
                  <v-col cols="6">
                    <v-card v-if="step == 0">
                      <v-img src="../assets/granmaa.png"></v-img>
                      <v-card-text>さてと・・・</v-card-text>
                    </v-card>
                    <v-card v-if="step == 1">
                      <v-img src="../assets/niginigi1.gif"></v-img>
                      <v-card-text class="text-blink">画像を生成しています</v-card-text>
                    </v-card>
                    <v-card v-if="step == 2">
                      <v-img src="../assets/niginigi2.gif"></v-img>
                      <v-card-text class="text-blink">ミントしています</v-card-text>
                    </v-card>
                    <v-card v-if="step == 3">
                      <v-img :src="`https://ipfs.io/ipfs/${pngCID}`"></v-img>
                      <v-card-text><a v-bind:href="openseaUrl" target="_blank">OpenSea</a>で、どうぞ&#x1f60a;</v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>

              <v-divider></v-divider>

              <v-card-actions v-if="step < 3">
                <v-spacer></v-spacer>
                <v-btn class="my-5" color="blue lighten-3" elevation="5" large @click="resetIds(), (page = 1)"
                  v-bind:disabled="step > 0">
                  戻る
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn class="my-5" color="red lighten-3" elevation="5" large @click="mint()" v-bind:disabled="walletAddress == '' ||
                  selectedCardsNumber() > ghnBalanceOf ||
                  selectedCardsNumber() == 0 ||
                  step > 0
                  ">
                  おにぎる！！
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>

              <v-card-actions v-if="step == 3">
                <v-spacer></v-spacer>
                <v-btn class="my-5" color="blue lighten-3" elevation="5" large @click="gotoStart()">
                  最初に戻る
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn class="my-5" color="blue lighten-3" elevation="5" large @click="closeWindow()">
                  ウィンドウを閉じる
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-col>
      </v-row>

    </v-container>
  </div>
</template>

<!--本体の背景設定など-->
<style>
.text-blink {
  animation: blink 1s linear infinite;
}

@keyframes blink {
  50% {
    opacity: 0;
  }
}
</style>

<script>
import WalletConnectProvider from "@walletconnect/web3-provider";
import { ethers, providers } from "ethers";
import axios from "axios";
import { NFTStorage, Blob } from 'nft.storage';
require("dotenv").config();

export default {
  name: "GLOnigiriClub",

  data: () => ({
    //設定・URL類
    config: {},
    openseaUrl: "",

    //ウォレット接続関係
    ghnContract: null,
    ongContract: null,
    provider: null,
    isMetamask: true, //Chrome拡張機能のMetamaskがあるかどうか
    walletAddress: "",
    web3Provider: null, //ethers.js
    signer: null, //ethers.js
    INFURA_ID: "",

    //画面切り替え用
    page: 0, //ページ切り替え 0:  1:SKB選択  2:バーンミント
    step: 0, //バーンミントのSTEP 0:初期値 1:SKBのバーンミント中 2:キャラバトンのバーン中 3:完了
    dialog: 0,

    pngCID: "",

    //GLOnigiriClubの所有確認 checkContract関数で取得
    ghnBalanceOf: 0,
    ghnTokensOfOwner: [],
    ghnOnEvent: false, //GLOCがイベントごはん開催中かどうかのフラグ
    paused: false, //GLOnigiriClubコントラクトのpause
    tokenIdToMint: 0, //次にミントするおにぎりのtokenId

    //GLOCの一覧表示と選択に使う配列
    nftCards: [], //保有SKBの一覧 {tokenId, thumbnailUrl}
    glocIdToOnigiri: 0, //おにぎりにするGLOCのtokenId
    isReadyToOnigiri: true, //前回おにぎりを作ってから所定の時間が経過しているか？

    //エラー処理
    hasError: false,
    errorMessage: "",
  }),

  mounted: async function () {
    try {
      //設定ファイルの読み込み
      //      this.hasError = false;
      this.config = require("./config/config.json");
    } catch (error) {
      console.log("error:", error.code);
      console.log("error:", error);
      this.hasError = true;
      this.errorMessage =
        "エラー(Code:" + error.code + "--" + error + ")@mounted";
    }
  },

  methods: {
    // ミント
    mint: async function () {
      // 進行中のマークをセット
      this.step = 1;
      var metadataCID = "";

      // PNGとメタデータの生成・アップロード
      metadataCID = await this.generatePngAndMetadata();

      // ミスった時に処理を止める・・・・//TODOエラー処理検討中
      if (metadataCID == "" || metadataCID == undefined) {
        throw "something is wrong in generating metadata";
      }

      this.step = 2;

      // トランザクションが詰まった時の処置用タイマー（3分待ってダメならダイアログ出す）
      const timer = setTimeout(this.giveUp, 180000);

      // contract実行
      try {
        //署名の取得(Netlify Functions)
        const signature = await this.getSignature(metadataCID);
        //Onigiriのmint
        //address to, 
        //string memory uri
        const ongTx = await this.ongContract.safeMint(
          this.glocIdToOnigiri,
          this.walletAddress,
          `ipfs://${metadataCID}`,
          signature,
          {
            from: this.walletAddress,
          }
        );

        const ongTxResp = await ongTx.wait();

        // トランザクションから返事があったら・・・
        // トランザクションが詰まった時の処置用タイマー止める
        clearTimeout(timer);

        if (ongTxResp.status == 0) {
          //トランザクション失敗
          this.hasError = true;
          this.errorMessage = "ミント・トランザクションエラー";
        } else {
          // 完了のダイアログ表示
          this.step = 3;
          //表示情報の更新
          //コントラクトからセール状況を取得
          await this.checkContract();
        }
      } catch (error) {
        // 進行中のマークを解除・処置用タイマー止める
        this.step = 0;
        clearTimeout(timer);
        // ウォレットで拒否した場合
        if (
          error.code == "ACTION_REJECTED" ||
          error.code == "4001" ||
          error == "Error: User rejected the transaction"
        ) {
          return;
        }
        console.log(error.code);
        console.log(error);
        this.hasError = true;
        this.errorMessage =
          "エラー(Code:" + error.code + "--" + error + ")@mint";
      }
    },


    generatePngAndMetadata: async function () {

      const NFT_STORAGE_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweDMyQjM2YThlQjlmMjM5OGJiN2RmRGIzQzczY0U4MGU2RmE5MkFiMGMiLCJpc3MiOiJuZnQtc3RvcmFnZSIsImlhdCI6MTY1OTI0MTg5MjExNSwibmFtZSI6ImRlc21vX2tleSJ9.JgekdScxt2MZVRbsXIYFdtxYMdyb5hDi_V9txbV2rMY'

      // PNGとメタデータを作成するtoken(Netlify Functionの処理時間の都合で1枚のみ)の情報を抜き出し
      const onigiriList = this.nftCards.filter((card) => card.selected == true);

      try {
        // ジェネPNGとメタデータの作成をNetlify Functionsに投げる→画像データとメタデータを受け取る
        let pngResp = await fetch("/.netlify/functions/generatePng", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(onigiriList),
        });

        const returnedData = await pngResp.json();

        if (pngResp.statusText == "Internal Server Error") {
          console.log("Internal Server Error")
        } else if (pngResp.status == 400 || pngResp.status == 500) {
          throw pngResp.statusText;
        }

        /**
         * 画像データの処理
         */
        let imageData = returnedData.imageData;

        // base64デコード
        const binaryData = Buffer.from(imageData, 'base64');
        // console.log("binaryData : ", binaryData);

        // IPFSにアップロード
        const storagePNG = new NFTStorage({ token: NFT_STORAGE_TOKEN })
        this.pngCID = await storagePNG.storeBlob(new Blob([binaryData]))
        console.log('image uploaded to ' + this.pngCID)

        /**
         * メタデータの処理
         */
        let attributes = returnedData.metadata;

        // 追加
        attributes.push({ trait_type: 'pngCID', value: (this.pngCID).toString() });
        attributes.push({ trait_type: 'tokenIdToMint', value: (this.tokenIdToMint).toString() });
        // console.log("metadata : ", metadata);

        // TODOエラー処理検討中
        if (attributes[7].value == undefined) {
          throw "something is wrong in attributes";
        }

        // メタデータの整形
        const metadata = await this.formatMetadata(attributes);
        // console.log("metadata : ", metadata);

        // IPFSにアップロード
        const storageMetadata = new NFTStorage({ token: NFT_STORAGE_TOKEN })
        const metadataCID = await storageMetadata.storeBlob(new Blob([metadata]))
        console.log('metadata uploaded to ' + metadataCID)

        // メタデータの整形とアップロードを投げる→メタデータのCIDを受け取る
        // let metadataResp = await fetch("/.netlify/functions/generateMetadata", {
        //   method: "POST",
        //   headers: {
        //     "Content-Type": "application/json",
        //   },
        //   body: JSON.stringify(metadata),
        // });

        // if (metadataResp.status == 400 || metadataResp.status == 500) {
        //   throw metadataResp.statusText;
        // }

        return metadataCID;

      } catch (error) {
        console.log("error:", error.code);
        console.log("error:", error);
        this.hasError = true;
        this.errorMessage =
          "エラー(Code:" + error.code + "--" + error + ")@generatePngAndMetadata";
      }
    },

    formatMetadata: async function (attributes) {
      try {

        // JSON形式に整形
        const metadata = JSON.stringify({
          name: `Onigiri #${attributes[8].value}`,
          description: "Special Onigiri made for you!",
          image: `ipfs://${attributes[7].value}`,
          background_color: "FFFFFF",
          attributes: [
            {
              trait_type: "Haikei",
              value: attributes[0].value
            },
            {
              trait_type: "Hashi_oki",
              value: attributes[1].value
            },
            {
              trait_type: "Hashi",
              value: attributes[2].value
            },
            {
              trait_type: "Sara",
              value: attributes[3].value
            },
            {
              trait_type: "Onigiri",
              value: attributes[4].value
            },
            {
              trait_type: "Nori",
              value: attributes[5].value
            },
            {
              trait_type: "Okazu",
              value: attributes[6].value
            }
          ]
        })

        return metadata;
      } catch (error) {
        console.log("error:", error.code);
        console.log("error:", error);
        this.hasError = true;
        this.errorMessage =
          "エラー(Code:" + error.code + "--" + error + ")@formatMetadata";
      }
    },

    closeWindow: async function () {
      window.close();
    },

    getSignature: async function (metadataCID) {
      const message = JSON.stringify([
        this.walletAddress,
        `ipfs://${metadataCID}`,
      ]);

      try {
        let resp = await fetch("/.netlify/functions/makeSignature", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: message,
        });

        if (resp.status == 400 || resp.status == 500) {
          throw resp.statusText;
        } else {
          return (await resp.json()).signature;
        }
      } catch (error) {
        console.log("error:", error.code);
        console.log("error:", error);
        this.hasError = true;
        this.errorMessage =
          "エラー(Code:" + error.code + "--" + error + ")@submit";
      }
    },

    // おにぎりにするGLOCのtokenIDをゼロに戻す
    resetIds: function () {
      this.glocIdToOnigiri = 0;
    },

    // おにぎりにするGLOCのtokenIDを取得
    countIds: function () {
      for (var index = 0; index < this.nftCards.length; index++) {
        if (this.nftCards[index].selected) {
          this.glocIdToOnigiri = this.nftCards[index].title;
        }
      }
    },

    // おにぎりにする数(必ず1なので本当は不要な関数)
    selectedCardsNumber: function () {
      return this.nftCards.filter((card) => card.selected == true).length;
    },

    select: async function (index) {
      if (this.nftCards[index].selected) {
        this.nftCards[index].selected = true;
      } else {
        const isReadyToOnigiri = await this.ongContract.isReadyToOnigiri(this.nftCards[index].title);
        // console.log("token Id : ", this.nftCards[index].title, "ready to Onigiri? : ", isReadyToOnigiri);
        if (!isReadyToOnigiri) {
          this.nftCards[index].isReadyToOnigiri = false;
          return;
        } else {
          for (const card of this.nftCards) {
            card.selected = false;
          }
          this.nftCards[index].selected = true;
        }
      }
    },

    makeNftCards: async function () {
      try {
        for (const token of this.ghnTokensOfOwner) {

          // console.log("token : ", token);

          const output = await this.getData(token);
          //console.log(output)
          const tokenId = output.id.tokenId;
          const cid = output.media[0].raw.slice(7, output.media[0].raw.length)
          const imageUrl = "https://ipfs.io/ipfs/" + cid;
          const attributes = output.metadata.attributes;
          //          const isReadyToOnigiri = await this.ongContract.isReadyToOnigiri(token);

          this.nftCards.push({
            title: tokenId,
            src: imageUrl,
            attributes: attributes,
            selected: false,
            isReadyToOnigiri: true,
            // isReadyToOnigiri: isReadyToOnigiri
          });
        }

        // console.log("this.nftCards : ", this.nftCards);

      } catch (e) {
        console.error("エラー：", e.message);
      }
    },

    getData: async function (token) {
      var outputData = [];

      const options = {
        method: 'GET',
        url: `https://polygon-mainnet.g.alchemy.com/nft/v2/UtDAA-501aDpUOC1Ls2dUfJLropMeMJf/getNFTMetadata`,
        params: {
          contractAddress: this.config.ghn_contract_address,
          tokenId: `${token}`,
          refreshCache: 'true'
        },
        headers: { accept: 'application/json' }
      };

      await axios
        .request(options)
        .then(function (response) {
          outputData = response.data;
          //          console.log(response.data);
        })
        .catch(function (error) {
          console.error(error);
        });

      return outputData;
    },

    // ウォレットの接続
    connectWallet: async function () {
      try {
        //メタマスクがないorBraveウォレットがある場合=>WalletConnectへ
        if (!window.ethereum || window.ethereum.isBraveWallet) {
          this.isMetamask = false;
          this.provider = new WalletConnectProvider({
            infuraId: this.config.INFURA_ID,
            qrcodeModalOptions: {
              desktopLinks: [],
              mobileLinks: ["metamask"],
            },
          });
          await this.provider.enable();
          this.web3Provider = new providers.Web3Provider(this.provider);
          //メタマスクがあるブラウザの場合
        } else {
          this.isMetamask = true;
          this.web3Provider = new ethers.providers.Web3Provider(
            window.ethereum
          );
          await this.web3Provider.send("eth_requestAccounts", []);
        }

        //ウォレットアドレスの取得
        this.signer = await this.web3Provider.getSigner();
        this.walletAddress = await this.signer.getAddress();

        //イーサリアムメインネット接続確認して違う場合は切替えて以降の処理を中止
        const ans = await this.checkNetwork(this.isMetamask);
        if (!ans) {
          this.dialog = 1;
          return;
        }

        //読込み中ダイアログのオン
        this.dialog = 3

        //OpenSeaリンクの作成
        this.openseaUrl = this.config.opensea_url + this.walletAddress;

        //接続されたウォレットアドレスで2つのcontractに接続
        this.ghnContract = new ethers.Contract(
          this.config.ghn_contract_address,
          this.config.ghn_contract_abi,
          this.signer
        );

        this.ongContract = new ethers.Contract(
          this.config.ong_contract_address,
          this.config.ong_contract_abi,
          this.signer
        );



        //コントラクトからセール状況を取得
        await this.checkContract();

        //保有SKBのtokenIdとサムネイルを取得
        await this.makeNftCards();
        //        console.log('nftCards : ' + JSON.stringify(this.nftCards))

        //読込み中ダイアログのオフと画面の切り替え
        this.dialog = 0;
        this.page = 1;
      } catch (error) {

        this.dialog = 0;

        console.log("error:", error.code);
        console.log("error:", error);
        this.hasError = true;
        this.errorMessage =
          "エラー(Code:" + error.code + "--" + error + ")@connectWallet";
      }
    },

    // トランザクションに詰まったかMetamaskでスピードアップした場合の退避処理
    giveUp: function () {
      this.dialog = 2;
    },

    // 接続ネットワークの切り替え
    switchNetwork: async function () {
      try {
        if (this.isMetamask) {
          await window.ethereum.request({
            method: "wallet_switchEthereumChain",
            params: [{ chainId: this.config.targetNetworkId }],
          });
        } else {
          const RequestArguments = {
            method: "wallet_switchEthereumChain",
            params: [{ chainId: this.config.targetNetworkId }],
          };
          // Send JSON RPC requests
          await this.provider.request(RequestArguments);

          // Close provider session
          //await provider.disconnect()
        }
        // refresh
        window.location.reload();
      } catch (error) {
        console.log("error:", error.code);
        console.log("error:", error);
        this.hasError = true;
        this.errorMessage =
          "エラー(Code:" + error.code + "--" + error + ")@switchNetwork";
      }
    },

    // 接続ネットワークの確認
    checkNetwork: async function (isMetamask) {
      try {
        if (isMetamask) {
          const currentChainId = await window.ethereum.request({
            method: "eth_chainId",
          });

          // return true if network id is the same
          if (currentChainId == this.config.targetNetworkId) return true;
          // return false is network id is different
          return false;
        } else {
          const currentChainId = await this.signer.getChainId();
          //          console.log("chainId=" + currentChainId);

          // return true if network id is the same
          if (currentChainId == this.config.targetNetworkId) return true;
          // return false is network id is different
          return false;
        }
      } catch (error) {
        console.log("error:", error.code);
        console.log("error:", error);
        this.hasError = true;
        this.errorMessage =
          "エラー(Code:" + error.code + "--" + error + ")@checkNetwork";
      }
    },

    // ページの強制リロード
    gotoStart: async function () {
      window.location.reload();
    },

    // コントラクトの情報取得
    checkContract: async function () {
      try {
        //GLOnigiriClubコントラクト情報の取得
        this.paused = await this.ongContract.paused();
        this.tokenIdToMint = Number(await this.ongContract.tokenIdToMint());
        // console.log("this.tokenIdToMint : ", this.tokenIdToMint);

        //ghn保有数の取得(GLOCコントラクトより)
        this.ghnTokensOfOwner =
          (await this.ghnContract.tokensOfOwner(this.walletAddress))
            .map(x => Number(x));

        this.ghnBalanceOf = this.ghnTokensOfOwner.length;
        this.ghnOnEvent = await this.ghnContract.onEvent();

      } catch (error) {
        console.log("error:", error.code);
        console.log("error:", error);
        this.hasError = true;
        this.errorMessage =
          "エラー(Code:" + error.code + "--" + error + ")@checkContract";
      }
    },

  },
};
</script>